import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { slotTemplateQKeys } from "@hooks/queries/slotTemplate/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface DeleteSlotTemplateProps {
  templateId: string;
  deleteFutureSlots?: boolean;
}

export const useDeleteSlotTemplate = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ templateId, deleteFutureSlots = false }: DeleteSlotTemplateProps) => {
      return api.delete(`slot-templates/${templateId}`, {
        params: {
          delete_future_slots: deleteFutureSlots,
        },
      });
    },
    onSuccess: () => {
      showSuccessNotification({ message: "slot-template-deleted-success" });
      queryClient.invalidateQueries({ queryKey: slotTemplateQKeys.all() });
    },

    onError: (res: any) => {
      console.error("[From Delete Slot Template]", res);
      queryClient.invalidateQueries({ queryKey: slotTemplateQKeys.all() });
      handleErrors(res, "mutation");
    },
  });
};
